import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../_redux/usersActionsActions';
import * as commonColumnFormatters from '../../_common/column-formatters';
import * as columnFormatters from './column-formatters';
import {useUsersActionsContext} from '../context/UsersActionsContext';
import useInfiniteScrollControl from '../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../_common/components/CommonGrid/CommonGrid";

export function UsersActionsTable() {
  const prefix = 'users-actions-column';
  const intl = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'username',
      Header: intl.formatMessage({id: `${prefix}-username`, defaultMessage: 'User name'})
    },
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({id: `${prefix}-createdAt`, defaultMessage: 'Created at'})
    },
    {
      accessor: 'action',
      Header: intl.formatMessage({id: `${prefix}-action`, defaultMessage: 'Action'})
    },
    {
      accessor: 'relevantData',
      Header: intl.formatMessage({id: `${prefix}-relevantData`, defaultMessage: 'Relevant data'})
    },
    {
      accessor: 'result',
      Header: intl.formatMessage({id: `${prefix}-result`, defaultMessage: 'Result'})
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        username: commonColumnFormatters.BoldColumnFormatter(item.username),
        createdAt: commonColumnFormatters.DateColumnFormatter(item.createdAt, true),
        action: commonColumnFormatters.BoldColumnFormatter(item.action),
        relevantData: columnFormatters.ActionDataColumnFormatter(item),
        result: columnFormatters.ResultColumnFormatter(item.result),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'usersActions',
    UIContext: useUsersActionsContext(),
    getNewEntities: actions.getUsersActions,
    getNextEntities: actions.getNextUsersActions,
    onEntitiesChange: entities => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'users-actions-table'}
    />
  );
}
